import { ref, computed } from "vue";
import { defineStore } from "pinia";

export const useNavbarDateFilterStore = defineStore("navbarDateFilter", () => {
    const current_date = new Date();
    const end_of_month = new Date(current_date.getFullYear(), current_date.getMonth() + 1, 0);
    const selected_date_filter = ref(current_date.getMonth() + 1);
    const from = ref(new Date(
        current_date.getFullYear(),
        current_date.getMonth(),
        1
    ));
    const to = ref(new Date(
        current_date.getFullYear(),
        current_date.getMonth(),
        end_of_month.getDate()
    ));

    const resetFilter = () => {
        from.value = new Date(
            current_date.getFullYear(),
            current_date.getMonth(),
            1
        );
        to.value = new Date(
            current_date.getFullYear(),
            current_date.getMonth(),
            end_of_month.getDate()
        );
    }

    return { selected_date_filter, from, to, resetFilter };
});
